import React, {Component} from 'react';
import {Banner,Card, Select, Layout, FormLayout, TextField, Button} from '@shopify/polaris';
import '@shopify/polaris/styles.css';
import './account.css';
import {reqSave} from "../../api/index";
import memory from '../../utils/memory';
import storage from '../../utils/storage';
import { Redirect } from 'react-router-dom';

export default class Account extends Component{
    constructor(props) {
        super(props);
        this.state = {
            user_info:memory.user_info,
            partner_type_option:memory.setting.partner_type,
            name:memory.user_info.name,
            partner_type:memory.user_info.partner_type,
            email:memory.user_info.email,
            paypal_address:memory.user_info.paypal_address,
            name_error:false,
            banner_show:false,
            loading:false
        }   
    }

    validateUserInfo = () =>{
        let if_pass = 1;
        if(this.state.name === ''){
            if_pass = 0;
            this.setState({name_error:'Name is required'});
        }

        if(this.state.partner_type === ''){
            if_pass = 0;
            this.setState({partner_type_error:'Partner is required'});
        }

        return if_pass;
    }

    handleInputChange(name, val) {
        this.setState({
           [name]: val
        });
     }

    saveUserInfo = () =>{
        if(this.validateUserInfo() === 0)
        {
            return false;
        }

        this.setState({loading:true, banner_show:false});
        reqSave(this.state.name, this.state.partner_type).then(
            response => {
                this.state.user_info['name'] = this.state.name
                this.state.user_info['partner_type'] = this.state.partner_type

                //修改成功以后，刷新内存中的数据为最新的
                this.setState(
                    {banner_show:true, banner_status:'success', loading:false},
                    () =>{
                        storage.saveInfo('user_info', this.state.user_info);
                    }
                );
            }
        ).catch(
            error => {
                console.log(error);
            }
        )
    }

    
    render () {

        if(memory.user_info === '{}')
        {
            return <Redirect to="/login" />
        }

        let option = [];
        for(let index in this.state.partner_type_option)
        {
            let item = {};
            item.label = this.state.partner_type_option[index]['label'];
            item.value = this.state.partner_type_option[index]['value'];
            option.push(item);
        }


        let banner;
        if (this.state.banner_show) {
            banner = <Layout.Section>
                <Banner title="Success!" status={this.state.banner_status}></Banner>
            </Layout.Section>;
        }                    

        return (
            <div className="account">
                <Layout>
                    <Layout.Section>
                        <h1>Account details</h1>
                    </Layout.Section>

                    {banner}

                    <Layout.Section>
                        <Card sectioned>
                        <FormLayout>
                            <FormLayout.Group>
                                <TextField label="Name" value={this.state.name} onChange={val=> this.handleInputChange('name', val)} error={this.state.name_error} />
                                <TextField type="email" value={this.state.email} label="Email" disabled onChange={() => {}} />
                            </FormLayout.Group>
                            
                            <FormLayout.Group>
                                <TextField type="email" value={this.state.paypal_address} label="PayPal" disabled onChange={() => {}} />
                                <Select label="Partner type" value={this.state.partner_type} options={option} onChange={val=> this.handleInputChange('partner_type', val)} error={this.state.partner_type_error} />
                            </FormLayout.Group>
                        </FormLayout>
                        </Card>
                    </Layout.Section>

                    <Layout.Section>
                        <div className="save-button"><Button loading={this.state.loading} onClick={this.saveUserInfo} primary>Save</Button></div>
                    </Layout.Section>

                </Layout>
            </div>

        )
    }
}

